/* eslint-disable */
const IS_PROD = ["production", "prod"].includes(process.env.NODE_ENV)
// import {host} from "@/utils/config.js"
const host = window.location.protocol + '//' + window.location.host
import Vue from 'vue'
import VueRouter from 'vue-router'
import { Toast } from 'vant';
import {
	get
} from '@/utils/ajax'
Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'redirect_my',
		redirect: '/my'
		// component: () => import('@/views/index.vue')
	},
	{
		path: '/home',
		name: 'home',
		component: () => import('@/views/home/home.vue')
		//首页
	},
	{
		path: '/search',
		name: 'search',
		component: () => import('@/views/search/search.vue')
		//搜索
	},
	{
		path: '/home/introduction',
		name: 'introduction',
		component: () => import('@/views/home/introduction/introduction.vue')
		// 学会简介
	},
	{
		path: '/home/office',
		name: 'office',
		component: () => import('@/views/home/office/office.vue')
		// 办事处
	},
	{
		path: '/home/office/details',
		name: 'office_details',
		component: () => import('@/views/home/office/details.vue')
		// 办事处详情
	},
	{
		path: '/home/resources',
		name: 'resources',
		component: () => import('@/views/home/resources/resources.vue')
		// 教学园地
	},
	{
		path: '/home/resources/video',
		name: 'resources_video',
		component: () => import('@/views/home/resources/video.vue')
		// 教学园地-学习资源
	},
	{
		path: '/home/resources/office',
		name: 'resources_office',
		component: () => import('@/views/home/resources/office.vue')
		// 教学园地-推荐机构
	},
	{
		path: '/home/resources/officeDetail',
		name: 'resources_office_detail',
		component: () => import('@/views/home/resources/officeDetail.vue')
		// 教学园地-推荐机构
	},
	{
		path: '/home/resources/teachers',
		name: 'resources_teachers',
		component: () => import('@/views/home/resources/teachers.vue')
		// 教学园地-教师风采
	},
	{
		path: '/home/activityList',
		name: 'activityList',
		component: () => import('@/views/home/activityList/activityList.vue')
		// 活动报名
	},
	{
		path: '/home/activityList/people',
		name: 'activityList_people',
		component: () => import('@/views/home/activityList/people.vue')
		// 活动报名-活动详情（已报名人数）
	},
	{
		path: '/home/activityList/details',
		name: 'activityList_details',
		component: () => import('@/views/home/activityList/details.vue')
		// 活动报名-活动详情
	},
	{
		path: '/home/member',
		name: 'member',
		component: () => import('@/views/home/member/member.vue')
		// 会员中心
	},
	{
		path: '/home/member/search',
		name: 'member_search',
		component: () => import('@/views/home/member/search.vue')
		// 会员中心-筛选会员
	},
	{
		path: '/home/member/results',
		name: 'member_results',
		component: () => import('@/views/home/member/results.vue')
		// 会员中心-筛选会员结果
	},
	{
		path: '/home/expert',
		name: 'expert',
		component: () => import('@/views/home/expert/expert.vue')
		// 专家库
	},
	{
		path: '/home/expert/details',
		name: 'expert_details',
		component: () => import('@/views/home/expert/details.vue')
		// 专家风采
	},
	{
		path: '/home/teacher/teacher',
		name: 'teacher',
		component: () => import('@/views/home/teacher/teacher.vue')
		// 名师推荐
	},
	{
		path: '/home/teacher/detail',
		name: 'teacher_detail',
		component: () => import('@/views/home/teacher/detail.vue')
		// 名师推荐
	},
	{
		path: '/home/news/newsList',
		name: 'news_List',
		component: () => import('@/views/home/news/newsList.vue')
		// 资讯列表
	},
	{
		path: '/home/news/details',
		name: 'news_details',
		component: () => import('@/views/home/news/details.vue')
		// 资讯详情
	},
	{
		path: '/friends',
		name: 'friends',
		component: () => import('@/views/friends/friends.vue')
		// 友圈
	},
	{
		path: '/circleDetail',
		name: 'circleDetail',
		component: () => import('@/views/circle/circleDetail.vue')
		// 友圈
	},
	{
		path: '/musicHall',
		name: 'musicHall',
		component: () => import('@/views/musicHall/musicHall.vue')
		// 乐堂
	},
	{
		path: '/musicHall/classify',
		name: 'musicHall_classify',
		component: () => import('@/views/musicHall/classify.vue')
		// 乐堂-分类
	},
	{
		path: '/my',
		name: 'my',
		meta: {
			noNeedLogin: 1 // 不需要登录
		},
		component: () => import('@/views/my/my.vue')
		// 我的
	},
	{
		path: '/my/certification',
		name: 'my_certification',
		component: () => import('@/views/my/certification/certification.vue')
		// 我的-我的认证
	},
	{
		path: '/my/certification/certificationTeacher',
		name: 'certification_teacher',
		component: () => import('@/views/my/certification/certificationTeacher.vue')
		// 我的-认证名师
	},
	{
		path: '/my/certification/certificationExaminer',
		name: 'certification_examiner',
		component: () => import('@/views/my/certification/certificationExaminer.vue')
		// 我的-考官认证
	},
	{
		path: '/my/certification/card1',
		name: 'certification_card1',
		component: () => import('@/views/my/certification/card1.vue')
	},
	{
		path: '/my/certification/card2',
		name: 'certification_card2',
		component: () => import('@/views/my/certification/card2.vue')
	},
	{
		path: '/my/homePage',
		name: 'my_homePage',
		component: () => import('@/views/my/homePage/homePage.vue')
		// 我的-个人主页
	},
	{
		path: '/my/collection',
		name: 'my_collection',
		component: () => import('@/views/my/collection/collection.vue')
		// 我的收藏（名片）
	},
	{
		path: '/my/activity',
		name: 'my_activity',
		component: () => import('@/views/my/activity/activity.vue')
		// 我的-我的活动
	},
	{
		path: '/publish',
		name: 'publish',
		component: () => import('@/views/publish/publish.vue')
		// 发布个人动态
	},
	{
		path: '/video',
		name: 'video',
		component: () => import('@/views/video/video.vue')
		// 播放视频页面（页面带过来一个视频的url就行了）
	},
	{
		path: '/my/apply',
		name: 'apply',
		component: () => import('@/views/my/apply/apply.vue')
		// 我的-申请入会
	},
	{
		path: '/my/setting',
		name: 'setting',
		component: () => import('@/views/my/setting/setting.vue')
		// 我的-设置
	},
	{
		path: '/my/setting/pages',
		name: 'setting_pages',
		component: () => import('@/views/my/setting/pages.vue')
		// 我的-设置（关于隐私、关于该系统）
	},
	{
		path: '/my/suggest',
		name: 'suggest',
		component: () => import('@/views/my/suggest/suggest.vue')
		// 我的-建言献策
	},
	{
		path: '/my/watch',
		name: 'watch',
		component: () => import('@/views/my/watch/watch.vue')
		// 我的-我的关注（我的粉丝）
	},
	{
		path: '/my/personalInfo',
		name: 'my_personalInfo',
		component: () => import('@/views/my/personalInfo.vue')
		// 我的-个人资料
	},
	{
		path: '/my/payMoney',
		name: 'my_payMoney',
		component: () => import('@/views/my/payMoney.vue')
		// 我的-缴纳会费
	},
	{
		path: '/login/login',
		name: 'login',
		meta: {
			noNeedLogin: 1
		},
		component: () => import('@/views/login/login.vue')
		// 微信授权页面
	},
	{
		path: '/login/loginPhone',
		name: 'loginPhone',
		component: () => import('@/views/login/loginPhone.vue')
		// 微信手机授权页面
	}
]

const router = new VueRouter({
	routes
})

router.beforeEach(function(to, from, next) {
	if (to.meta && to.meta.title) {
		document.title = to.meta.title
	} else {
		document.title = "福建省民族管弦乐学会"
	}
	// next()
	const TOKEN = localStorage.getItem('TOKEN')
	let code = to.query.code || ''
	const activity_id = to.query.activity_id
	const href = window.location.href
	const arr = href.split('?code=')
	// const inviter_id = to.query.inviter_id
	
	let noIndexHref = `${host}/dist/#/`
	// let noIndexHref = `${host}/dist/#/?activity_id=${activity_id}`

	// if (activity_id) {
	// 	localStorage.setItem('activity_id', activity_id)
	// }
	// if (inviter_id) {
	// 	noIndexHref = `${host}/dist/#/?activity_id=${activity_id}&inviter_id=${inviter_id}`
	// }
	if (!IS_PROD || to.meta.noNeedLogin == 1) { // 测试环境用
	// if (to.meta.noNeedLogin == 1) { // 测试环境用
		next()
		return false
	} else {
		// var ua = navigator.userAgent.toLowerCase()
		// if (!(ua.match(/MicroMessenger/i) == "micromessenger")) { // 检测是否微信环境
		// 	localStorage.removeItem('TOKEN')
		// 	window.location.href = host + '/api/wechat/login?callback_url=' + encodeURIComponent(noIndexHref)
		// }
	}
	if (arr[1]) {
		// code = code ? code : arr[1].split('#/')[0]
		code = code ? code : ''
		console.log(code)
	}
	// if (activity_id) {
	// 	localStorage.setItem('activity_id', activity_id)
	// }
	if (code) { // 有code 则不跳转授权
		get('wechat/getToken', {
			code
		}).then(res => {
			// console.log('codeRes' ,res)
			if (res.code === 2000) {
				console.log(res,"授权後后端给的 数据");
				localStorage.setItem('TOKEN', res.data.token)
				localStorage.setItem('user_id', res.data.user.user_id)
				localStorage.setItem('mobile', res.data.user.mobile)
				if (res.data.user.mobile){
					next({'name': 'my'})
				} else {
					next({'name': 'loginPhone'})
				}
				// localStorage.setItem('subscribe', res.data.user.subscribe)
				// localStorage.setItem('userInfo', res.data.user)
				// if (inviter_id) {
				// 	get('/api/index/shareCallback', {
				// 		inviter_id
				// 	})
				// }
				// next()
			} 
			// else {
			// 	localStorage.removeItem('TOKEN')
			// 	localStorage.removeItem('user_id')
			// 	window.location.href = host + '/api/wechat/login?callback_url=' + encodeURIComponent(noIndexHref)
			// }
		})
	} else {
		if (!TOKEN) {
			noIndexHref = `${host}/dist/#/login/loginPhone`
			
			if (to.name != 'loginPhone') {
				next({'name': 'login'})
			} else {
				localStorage.removeItem('TOKEN')
				window.location.href = host + '/wechat/login?callback_url=' + encodeURIComponent(noIndexHref)
			}
			
			// localStorage.removeItem('TOKEN')
			// window.location.href = host + '/api/wechat/login?callback_url=' + encodeURIComponent(noIndexHref)
		} else {
			// if (inviter_id) {
			// 	get('/api/index/shareCallback', {
			// 		inviter_id
			// 	})
			// }
			next()
		}
	}
})

export default router
